module.exports = __webpack_public_path__ + "media/widget/medical_diagnosis-2653d9fd.png";